import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import ImgContainer from "components/common/img";
import { useNavigate } from "react-router";
import styled from "styled-components";

const PartyContainerWrapper = styled(Row)`
  background: #ffffff;
  border-radius: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 125px;
  margin: 0;
  padding-right: 0;
  padding-left: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;

  &:hover {
    h6 {
      color: ${({ theme }) => theme.colors.systemBlue};
    }
  }

  @media (max-width: 768px) {
    img {
      height: 70px;
    }
  }
`;

const PartyLabelContainer = styled(Col)`
  padding: 0;

  @media (max-width: 575px) {
    display: none;
  }
`;

const PartyLabel = styled.h6`
  margin: 0;
`;

const PartyContainer = (props) => {
  const navigate = useNavigate();

  const handleOnClick = (e) => {
    e.preventDefault();
    navigate(props?.link);
  };

  return (
    <PartyContainerWrapper onClick={handleOnClick}>
      <Col xs="auto">
        <ImgContainer
          alt="party-logo"
          height="90px"
          width="90px"
          src={props.photo}
        />
      </Col>
      <PartyLabelContainer>
        <PartyLabel>{props?.label}</PartyLabel>
      </PartyLabelContainer>
    </PartyContainerWrapper>
  );
};

PartyContainer.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
};

export default PartyContainer;
